import React from 'react';
import { validateByJoi } from '../utilities/validation';
import * as _ from 'lodash';
import _slideLoader from '../utilities/slideLoader';
import EventMg from '../utilities/EventManager';
import ReportNames from '../utilities/reportNames';
import PrintUtility from '../utilities/printUtility';
import moment from 'moment';
import Helmet from 'react-helmet';
import SessionStorageService from '../services/utilities/SessionStorageService';
import {
  API_FLAG, // APIフラグ用
  WORKER_TYPES, // 契約状態
  SCHEDULE_STATUS, // 予定実績フラグ
  SYSTEM_WORKER_COUNT, // 時間
  WORK_EARLY_OVER_TYPES, // 早出残業フラグ
  WORK_HOUR_ZONES, // 作業時間帯
  HEADER_CONSTANTS,
  STATUS_CODE,
  KEY_MESSAGES_REQUIRE_INPUT_PLACE,
  NUMBER_OF_FIELD_ITEM_TYPE,
  REQUIRE_WORK_PLACE,
  CONST_ABCD__PLACE_AND_SUB_WORK,
  PRIVATE_PARTNER_COMPANY_LABEL,
} from '../utilities/constants';

import { isApiFlagOn } from '../utilities/commonUtil';

import dialogLoader from '../utilities/dialogLoader';
import { FieldService } from '../services/Fields'; // 現場マスタAPI
import { FieldItemService } from '../services/FieldItems'; // 現場作業エリア情報取得API
import { FieldImageService } from '../services/FieldImages';
import { WorkScheduleService } from '../services/Works'; // 作業予定API
import { CompanyBranchService } from '../services/CompanyBranches'; // 入力項目管理リストAPI
import { WorkScheduleForm } from '../components/forms/WorkSchedule'; // フォーム
import { PrintService } from '../services/Prints'; // 帳票API
import workEditDefaultState from '../utilities/workEditDefaultState';
import workEditFormSchema from '../utilities/validationSchemas/workEdit';
import { workHourBatchEditSchema } from '../utilities/validationSchemas/workMultipleEdit';
import { messageUtility } from '../utilities/messageUtility';
import { isLoginUserPartnerCompany } from '../utilities/roleUtility';
import { deleteControlCode } from '../utilities/stringUtil';
import { ErrorDialog } from '../components/dialogs/ErrorDialog';
import ClipLoader from 'react-spinners/ClipLoader';
import { ConferencePageHeader } from '../components/PageHeader';
import { CloseEditView } from '../components/CloseEditView';
import ProgressService from '../services/Progress';
import { isPrimeContractorHasBlockedOrFinishedWorkError } from '../utilities/apiErrorMessage';
import { FormInformationDialog } from '../components/FormInformationDialog';
import { Confirmation } from '../components/modals/common';
import { CancelAndConfirmDialog } from '../components/modals/CancelAndConfirmDialog';
import { SptService } from '../services/Spt';

const MY_EVENT = {
  LOAD_GROUP_DATA: 'load_group_data', // 一覧取得
};

const WORK_HOUR_KEYS = [
  'dayworker_type',
  'display_fifteen_minute_flg',
  'work_dayworkers',
  'woman',
  'non_japanese',
  'work_early_times',
  'work_over_times',
];

/**
 * 「作業予定一覧 / 作業実績一覧」共通
 *  新規作成 / 編集 共通
 */
export class WorkEdit extends React.Component {
  constructor(props) {
    super(props);

    // 1-3は支店項目優先
    this.optionListNumbers = [
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
    ];

    this.state = workEditDefaultState(props);

    this.fieldId = SessionStorageService.getFieldId();
    this.temporaryWorkPlaceRequireType = null;
    this.events = {
      modal: {
        goBack: this.handleGoBackDialog.bind(this), // 戻る
        showDelete: this.handleDeleteDialog.bind(this), // 削除
        showAbort: this.handleAbortDialog.bind(this), // 中止
        showResume: this.handleResumeDialog.bind(this), // 中止解除
      },
      form: {
        set: this.setFlatData.bind(this), // 入力
        dropdown: this.setDropdownData.bind(this), // ドロップダウン選択
        keyplan: this.setDropdownKeyplanData.bind(this), // キープラン選択
        set15Time: this.set15Time.bind(this), // 15分単位で計算
        update: this.eventUpdate.bind(this), // 更新
        calender: this.setDate.bind(this), // 期間選択
        print: this.callDocurain.bind(this), // 酸欠帳票出力 // 統合メモ: 酸欠帳票出力は作業予定の編集画面にしかない(V1仕様)
        deleteKeyPlan: this.deleteKeyPlan.bind(this), // キープラン削除
        setEditKeyplanFlag: this.setEditKeyplanFlag.bind(this), // キープラン編集済みフラグ
        validate: this.validateValue.bind(this), // バリデーション
        workDayTime: {
          // 人工
          set: this.setWorkDayTime.bind(this), // 入力
          add: this.addWorkDayTime.bind(this), // 追加
          remove: this.removeWorkDayTime.bind(this), // 削除
        },
        earlyOverTime: {
          // 早出残業
          set: this.setEarlyOverTime.bind(this), // 入力
          add: this.addEarlyOverTime.bind(this), // 追加
          remove: this.removeEarlyOverTime.bind(this), // 削除
        },
      },
    };

    this.initForm = this.initForm.bind(this); // フォーム生成
    this.getOvertimeStart = this.getOvertimeStart.bind(this); // 早出開始時間計算
    this.getEarlytimeEnd = this.getEarlytimeEnd.bind(this); // 残業終了時間計算
    this.checkRequired = this.checkRequired.bind(this); // 必須項目入力状況監視
    this.checkEarlyOverTimes = this.checkEarlyOverTimes.bind(this); // 早出・残業入力判定

    if (this.props.isWorkBatchEdit) {
      this.schema = workHourBatchEditSchema;
    } else {
      this.schema = workEditFormSchema;
    }

    const { isWorkSchedule } = this.props;

    // 削除
    this.DeleteSchedule = {
      isWorkSchedule,
      callback: {
        deleteSchedule: () => {
          this.deleteWorkSchedule(true);
          dialogLoader.close();
        },
      },
    };

    // 中止
    this.AbortSchedule = {
      isWorkSchedule,
      callback: {
        abortSchedule: () => {
          this.abortWorkSchedule();
          dialogLoader.close();
        },
      },
    };

    // 中止解除
    this.ResumeSchedule = {
      isWorkSchedule,
      callback: {
        resumeSchedule: () => {
          this.resumeWorkSchedule();
          dialogLoader.close();
        },
      },
    };

    // 戻るダイアログ
    this.GoBack = {
      callback: {
        close: () => {
          dialogLoader.close();
        },
        clear: () => {
          EventMg.trigger(MY_EVENT.LOAD_GROUP_DATA, true);
          _slideLoader.close(this.props.vw);
          dialogLoader.close();
        },
      },
    };

    this.updatingFlag = false;
    this.setLoadedKeyPlanData = this.setLoadedKeyPlanData.bind(this);
    this.updateKeyPlan = this.updateKeyPlan.bind(this);
  }

  async componentDidMount() {
    if (this.props.isWorkBatchEdit) {
      await this.initWorkScheduleFromProps();
      this.setState({
        isWorkHourModalLoaded: true,
      });
      return;
    }
    if (this.props.isWorkHourModal) {
      await this.setWorkSchedule();
      this.setState({
        isWorkHourModalLoaded: true,
      });
      return;
    }
    // 現場情報取得
    await FieldService.fieldItem(this.state.fieldId).then(response => {
      if (response.result === false) {
        return;
      }
      const formValues = { ...this.state.formValues };
      const requiredInput = { ...this.state.requiredInput };
      const fieldItem = response.data.entities.field_item;
      const item_list_ids = [1, 2, 3, 4];

      _.each(this.optionListNumbers, num => {
        // 項目設定数より大きい場合は必須フラグは見ない
        if (num > fieldItem.create_item_count) {
          return;
        }
        fieldItem[`option${num}_display_flag`] === 1
          ? (formValues[`option${num}_must_flag`] =
              fieldItem[`option${num}_must_flag`] || 0)
          : (formValues[`option${num}_must_flag`] = 0);
      });

      _.each(this.optionListNumbers, num => {
        if (
          formValues[`option${num}_must_flag`] === 1 &&
          // 項目設定数より大きい場合は必須項目としない
          num <= fieldItem.create_item_count
        ) {
          requiredInput.columns.push(`option${num}`);
        }
      });

      _.map(item_list_ids, (itemListId, key) => {
        if (fieldItem[`field_item_list${itemListId}_display_flag`] === 0) {
          item_list_ids.splice(key, 1);
        }
      });

      if (item_list_ids.length === 0) {
        // 必須要件の合計をrequiredInput.totalに設定する
        requiredInput.total = requiredInput.columns.length;
        this.setState({ requiredInput, fieldItem, formValues });
        this.checkRequired(formValues);
        return;
      }
      const params = {
        item_list_ids,
        is_limit: 1,
        offset: 0,
        limit: 30,
        // 有効のものだけ表示
        display_flag: 1,
      };

      // 現場作業エリア情報取得API
      FieldItemService.list(this.state.fieldId, params).then(response => {
        if (response.result === false) {
          return;
        }

        this.setState({
          requiredInput,
          fieldItem,
          formValues,
          options: response.data.entities,
        });
      });

      // 必須要件の合計をrequiredInput.totalに設定する
      requiredInput.total = requiredInput.columns.length;
      this.checkRequired(formValues);
    });

    // 項目カスタマイズAPI
    await CompanyBranchService.companyItemOrders(this.state.fieldId).then(
      response => {
        if (response.result) {
          const companyItemOrders = _.get(
            response,
            'data.entities.company_item_orders'
          );
          this.setState({
            companyItemOrders,
          });
        }
      }
    );

    await ProgressService.getProgressFieldSettings(this.state.fieldId).then(
      async responseFieldSettings => {
        if (
          responseFieldSettings.result &&
          _.get(responseFieldSettings, 'data.entities.progress_field_settings')
        ) {
          const responseFieldMainWork = await ProgressService.getProgressFieldMainWorkTypes(
            this.state.fieldId,
            {
              limit: 1,
              include_other_flag: 1,
            }
          );
          this.setState({
            progress_date_from: _.get(
              responseFieldSettings,
              'data.entities.progress_field_settings.input_start_date'
            ),
            progress_date_to: _.get(
              responseFieldSettings,
              'data.entities.progress_field_settings.input_end_date'
            ),
            lengthOfListMainWorkTypes:
              _.get(responseFieldMainWork.data, 'total') || 0,
          });
        }
      }
    );

    // システム管理者からのデーター取得
    await CompanyBranchService.companyItemSettings(this.state.fieldId).then(
      response => {
        if (response.result) {
          const companyItemSettings =
            response.data.entities.company_item_settings;
          const formValues = _.cloneDeep(this.state.formValues);

          if (_.isEmpty(companyItemSettings)) {
            alert('データを取得できませんでした。');
            console.error('データ取得失敗：company_item_settings');
            return;
          }
          const option1 = _.find(companyItemSettings, {
            item_name: 'item_1',
          });
          const option2 = _.find(companyItemSettings, {
            item_name: 'item_2',
          });
          const option3 = _.find(companyItemSettings, {
            item_name: 'item_3',
          });
          if (option1) {
            option1.item_display_flag === 1
              ? (formValues.option1_must_flag = option1.item_must_flag)
              : (formValues.option1_must_flag = 0);
          }
          if (option2) {
            option2.item_display_flag === 1
              ? (formValues.option2_must_flag = option2.item_must_flag)
              : (formValues.option2_must_flag = 0);
          }
          if (option3) {
            option3.item_display_flag === 1
              ? (formValues.option3_must_flag = option3.item_must_flag)
              : (formValues.option3_must_flag = 0);
          }

          // 項目カスタマイズで「必須」に設定された項目をrequiredInput.columnsに追加
          const requiredInput = _.cloneDeep(this.state.requiredInput);
          if (formValues.option1_must_flag === 1) {
            requiredInput.columns.push('option1');
          }
          if (formValues.option2_must_flag === 1) {
            requiredInput.columns.push('option2');
          }
          if (formValues.option3_must_flag === 1) {
            requiredInput.columns.push('option3');
          }

          // 必須要件の合計をrequiredInput.totalに設定する
          requiredInput.total = requiredInput.columns.length;
          this.setState({ companyItemSettings, formValues, requiredInput });
          this.checkRequired(formValues);
        }
      }
    );
    await this.setWorkSchedule();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.formValues.dayworker_type !==
      this.state.formValues.dayworker_type
    ) {
      // 人工種別が変更された時、各人工の人工種別を変更する
      this.updateDayworkerTypeInWorkDayworkers(
        this.state.formValues.dayworker_type
      );
    }
  }

  async setWorkSchedule() {
    await WorkScheduleService.show(
      this.state.fieldId,
      this.state.scheduleId
    ).then(async response => {
      if (!response.result) {
        return;
      }
      const schedule = response.data.entities;
      const isExistOxygenLack =
        schedule.work.oxygen_lack_dangerous_work_upper ||
        schedule.work.oxygen_lack_dangerous_work_lower ||
        schedule.work.oxygen_lack_education_complete_upper ||
        schedule.work.oxygen_lack_education_complete_lower;
      this.temporaryWorkPlaceRequireType = schedule.work.required_item_list_ids;
      this.setState(
        {
          isExistOxygenLack,
          formValues: {
            ...this.state.formValues,
            main_work_type_id: schedule.work.main_work_type_id,
            sub_work_type_id: schedule.work.sub_work_type_id,
            main_work_type_name: schedule.work.duplicate_name_flag
              ? `${schedule.work.main_work_type_name}（${
                  schedule.work.template_name
                }）`
              : schedule.work.main_work_type_name,
            sub_work_type_name: schedule.work.sub_work_type_name,
            isSubTypeRequired: !!schedule.work.sub_work_type_id,
            duplicate_name_flag: schedule.work.duplicate_name_flag,
            template_name: schedule.work.template_name,
          },
        },
        () => {
          this.setVisibleMainSubWorkDropdown(schedule.work_group.work_date);
          if (!this.props.isWorkHourModal){
            this.getSptLinkageSetting(schedule.work_group.work_date);
          }
        }
      );

      const isQuiet = true;
      // 現場情報の取得(単一レコード)
      await FieldService.info(this.state.fieldId, {}, isQuiet).then(
        response => {
          if (!response.result) {
            return;
          }
          const field = response.data.entities.field;
          const { workHour, workTime } = this.getWorkTimeAndWorkHour(
            schedule.work_group.work_date,
            field
          );

          const fieldItem = _.cloneDeep(this.state.fieldItem);
          fieldItem.oxygen_lack_print_flag = field.oxygen_lack_print_flag;
          this.setState({
            isFifteen: schedule.work.display_fifteen_minute_flg,
            approvedFlag: isApiFlagOn(schedule.work.approved_flag),
            partnerCompanyApprovalFlag:
              this.state.usePartnerCompanyApprovalFlag &&
              schedule.work.partner_company_approval_flag === API_FLAG.On,
            fieldItem,
            workTimes: field.work_hour,
            workTime,
            loaded: true,
            checkInReflectToResultFlag: this.getCheckInReflectToResultFlag(
              field
            ),
          });
          let fieldWorkingHour = moment
            .duration(workHour.worker_work_time)
            .asHours();
          // eslint-disable-next-line no-unused-vars
          const workDaywokers = _.map(
            schedule.work_dayworkers,
            workDayworker => {
              if (workDayworker.working_temp_hour > fieldWorkingHour) {
                workDayworker.working_temp_hour = fieldWorkingHour;
              }
              return workDayworker;
            }
          );
          this.initForm(schedule);
        }
      );
    });
    this.loadReflectWorkTotal();
  }

  getCheckInReflectToResultFlag = field => {
    return (
      _.get(field, 'use_check_in_reflect_to_result_flag') &&
      moment().isAfter(
        _.get(field, 'use_check_in_reflect_to_result_start_date'),
        'day'
      )
    );
  };

  getWorkTimeAndWorkHour = (workDate, field) => {
    let workHour = '';
    if (_.size(field.work_hour) === 1) {
      workHour = field.work_hour[0];
    } else {
      const sortedWorkHours = _.sortBy(field.work_hour, 'start_date');
      workHour = _.last(
        _.filter(sortedWorkHours, w =>
          moment(w.start_date).isSameOrBefore(workDate)
        )
      );
      if (!workHour) {
        workHour = _.head(
          _.filter(sortedWorkHours, w => moment(w.start_date).isAfter(workDate))
        );
      }
    }
    const workTime = _.cloneDeep(this.state.workTime);
    workTime[WORK_HOUR_ZONES.day.id] = _.assign(
      workTime[WORK_HOUR_ZONES.day.id],
      { start: field.work_start_time }
    ); // 労働開始時刻（昼）
    workTime[WORK_HOUR_ZONES.day.id] = _.assign(
      workTime[WORK_HOUR_ZONES.day.id],
      { end: field.work_end_time }
    ); // 労働終了時刻（昼）
    workTime[WORK_HOUR_ZONES.day.id] = _.assign(
      workTime[WORK_HOUR_ZONES.day.id],
      { working_time: workHour.worker_work_time }
    ); // 作業時間
    workTime[WORK_HOUR_ZONES.day.id] = _.assign(
      workTime[WORK_HOUR_ZONES.day.id],
      {
        earlytime_end: field.earlytime_end
          ? field.earlytime_end.slice(0, -3)
          : '00:00',
      }
    ); // 早出終了時間（昼）
    workTime[WORK_HOUR_ZONES.day.id] = _.assign(
      workTime[WORK_HOUR_ZONES.day.id],
      {
        overtime_start: field.overtime_start
          ? field.overtime_start.slice(0, -3)
          : '00:00',
      }
    ); // 残業開始時間（昼）
    workTime[WORK_HOUR_ZONES.night.id] = _.assign(
      workTime[WORK_HOUR_ZONES.night.id],
      { start: field.work_start_time_night }
    ); // 労働開始時刻（夜）
    workTime[WORK_HOUR_ZONES.night.id] = _.assign(
      workTime[WORK_HOUR_ZONES.night.id],
      { end: field.work_end_time_night }
    ); // 労働終了時刻（夜）
    workTime[WORK_HOUR_ZONES.night.id] = _.assign(
      workTime[WORK_HOUR_ZONES.night.id],
      { working_time: workHour.worker_work_time }
    ); // 作業時間
    workTime[WORK_HOUR_ZONES.night.id] = _.assign(
      workTime[WORK_HOUR_ZONES.night.id],
      {
        earlytime_end: field.earlytime_end_night
          ? field.earlytime_end_night.slice(0, -3)
          : '00:00',
      }
    ); // 早出終了時間（夜）
    workTime[WORK_HOUR_ZONES.night.id] = _.assign(
      workTime[WORK_HOUR_ZONES.night.id],
      {
        overtime_start: field.overtime_start_night
          ? field.overtime_start_night.slice(0, -3)
          : '00:00',
      }
    ); // 残業開始時間（夜）
    workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
      workTime[WORK_HOUR_ZONES.midnight.id],
      { start: field.work_start_time_midnight }
    ); // 労働開始時刻（深夜）
    workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
      workTime[WORK_HOUR_ZONES.midnight.id],
      { end: field.work_end_time_midnight }
    ); // 労働終了時刻（深夜）
    workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
      workTime[WORK_HOUR_ZONES.midnight.id],
      { working_time: workHour.worker_work_time }
    ); // 作業時間
    workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
      workTime[WORK_HOUR_ZONES.midnight.id],
      {
        earlytime_end: field.earlytime_end_midnight
          ? field.earlytime_end_midnight.slice(0, -3)
          : '00:00',
      }
    ); // 早出終了時間（深夜）
    workTime[WORK_HOUR_ZONES.midnight.id] = _.assign(
      workTime[WORK_HOUR_ZONES.midnight.id],
      {
        overtime_start: field.overtime_start_midnight
          ? field.overtime_start_midnight.slice(0, -3)
          : '00:00',
      }
    ); // 残業開始時間（深夜）

    return { workHour, workTime };
  };

  initWorkScheduleFromProps = async () => {
    const schedule = _.cloneDeep(this.props.workData);
    const field = this.props.fieldInfo;
    const { workTime, workHour } = this.getWorkTimeAndWorkHour(
      schedule.work_date,
      field
    );

    await this.setState({
      isFifteen: schedule.display_fifteen_minute_flg,
      approvedFlag: isApiFlagOn(schedule.approved_flag),
      partnerCompanyApprovalFlag:
        this.state.usePartnerCompanyApprovalFlag &&
        schedule.partner_company_approval_flag === API_FLAG.On,
      workTimes: field.work_hour,
      workTime,
    });
    let fieldWorkingHour = moment.duration(workHour.worker_work_time).asHours();
    _.forEach(schedule.work_dayworkers, workDayworker => {
      if (workDayworker.working_temp_hour > fieldWorkingHour) {
        workDayworker.working_temp_hour = fieldWorkingHour;
      }
      return workDayworker;
    });
    const keysNotInWork = [
      'partner_company',
      'work_dayworkers',
      'work_early_times',
      'work_group',
      'work_hour',
      'work_key_plan_image',
      'work_over_times',
    ];
    schedule.work = _.pickBy(
      schedule,
      (value, key) => !_.includes(keysNotInWork, key)
    );
    this.initForm(schedule);
  };

  /**
   * @description 各人工の人工種別の更新
   * @param dayworkerType 人工種別
   */
  updateDayworkerTypeInWorkDayworkers = dayworkerType => {
    const formValues = _.cloneDeep(this.state.formValues);
    const updatedWorkDayworkers = _.map(
      formValues.work_dayworkers,
      workDayworker => ({
        ...workDayworker,
        dayworker_type: dayworkerType,
      })
    );
    formValues.work_dayworkers = updatedWorkDayworkers;
    this.setState({ formValues });
  };

  /**
   * 削除ダイアログ
   */
  handleDeleteDialog = () => {
    dialogLoader.show(DeleteDialog, this.DeleteSchedule);
  };

  /**
   * 中止ダイアログ
   */
  handleAbortDialog = () => {
    dialogLoader.show(AbortDialog, this.AbortSchedule);
  };

  /**
   * 戻るダイアログ表示
   */
  handleGoBackDialog = () => {
    dialogLoader.show(CloseEditView, this.GoBack);
  };

  /**
   * 中止解除ダイアログ
   */
  handleResumeDialog = () => {
    dialogLoader.show(ResumeDialog, this.ResumeSchedule);
  };

  /**
   * フォーム生成
   * @param data {object}  作業予定情報
   */
  initForm(data) {
    const workGroup = data.work_group;
    const work = data.work;
    const formValues = _.cloneDeep(this.state.formValues);
    const pulldownName = _.cloneDeep(this.state.pulldownName);
    // 既存dataの中にformValuesプロパティーが存在する場合、上書きする
    _.each(work, (val, index) => {
      if (formValues.hasOwnProperty(index)) {
        if (!_.isNull(val) || !_.isUndefined(val)) {
          formValues[index] = val;
        }
      }
    });
    formValues.work_hour_zone = workGroup.work_hour_zone;
    formValues.work_date = workGroup.work_date;
    formValues.field_tree_id = workGroup.field_tree_id;
    formValues.job_id = workGroup.job_id;
    formValues.foreman_user_id = workGroup.foreman_user_id;
    formValues.oxygen_lack_dangerous_work_upper =
      work.oxygen_lack_dangerous_work_upper;
    formValues.oxygen_lack_dangerous_work_lower =
      work.oxygen_lack_dangerous_work_lower;
    formValues.oxygen_lack_education_complete_upper =
      work.oxygen_lack_education_complete_upper;
    formValues.oxygen_lack_education_complete_lower =
      work.oxygen_lack_education_complete_lower;
    formValues.work_dayworkers = data.work_dayworkers.map(item => {
      item.dayworker = Number(item.dayworker).toFixed(2);
      return item;
    });

    // プルダウンの名前の初期値を取得
    pulldownName.company_name =
      workGroup.nest_no === 1
        ? workGroup.company_name
        : `${workGroup.company_name_1}（${workGroup.company_name}）`; // 協力会社名
    if (workGroup.private_partner_company_flag) {
      pulldownName.company_name += PRIVATE_PARTNER_COMPANY_LABEL;
    }
    pulldownName.job_name = workGroup.job_name; // 職名
    pulldownName.foreman_user_name = workGroup.foreman_user_name_sei
      ? `${workGroup.foreman_user_name_sei} ${workGroup.foreman_user_name_mei}`
      : ''; // 職長名
    pulldownName.a_item_name = work.a_item_name; // 作業場所A名
    pulldownName.b_item_name = work.b_item_name; // 作業場所B名
    pulldownName.c_item_name = work.c_item_name; // 作業場所C名
    pulldownName.d_item_name = work.d_item_name; // 作業場所D名
    pulldownName.manager_user_name = `${work.manager_user_name_sei} ${
      work.manager_user_name_mei
    }`; // 元請担当者名(sei,meiを結合)

    if (_.isEmpty(data.work_dayworkers)) {
      let workHourZone = this.state.formValues.work_hour_zone;
      let workingTime = this.state.workTime[workHourZone].working_time;
      let workingHour = '';
      if (work.display_fifteen_minute_flg) {
        workingHour = Number(moment.duration(workingTime).asHours());
      } else {
        workingHour = Number(1).toFixed(2);
      }
      const workDayworkers = {
        dayworker_type: formValues.dayworker_type,
        working_temp_person: '',
        working_temp_hour: workingHour,
        dayworker: '0.00',
      };
      formValues.work_dayworkers = [workDayworkers];
      formValues.non_japanese = 0;
      formValues.woman = 0;
    }
    if (_.isEmpty(data.work_early_times)) {
      let workHourZone = SessionStorageService.getItem('work_hour_zone');
      if (this.props.unapprovedFlag) {
        workHourZone = formValues.work_hour_zone;
      }
      const earlyWorkStart = '';
      const overWorkEnd = this.state.workTime[workHourZone].earlytime_end;
      const earlyOverTime = {
        fixed_unfixed_type: WORKER_TYPES.contractor.id,
        working_temp_person: SYSTEM_WORKER_COUNT[0].id,
        working_temp_hour: 0.0,
        overtime_start: earlyWorkStart,
        earlytime_end: overWorkEnd,
      };
      formValues.work_early_times = [earlyOverTime];
    } else {
      let workEarlyTimes = [];
      _.each(data.work_early_times, work_early_time => {
        let early = {
          id: work_early_time.id,
          working_temp_person: work_early_time.working_temp_person,
          working_temp_hour: work_early_time.working_temp_hour,
          overtime_start: this.getOvertimeStart(
            work_early_time.earlytime_end,
            work_early_time.working_temp_hour
          ),
          earlytime_end: work_early_time.earlytime_end.slice(0, -3),
        };
        workEarlyTimes.push(early);
      });
      formValues.work_early_times = workEarlyTimes;
    }
    if (_.isEmpty(data.work_over_times)) {
      let workHourZone = SessionStorageService.getItem('work_hour_zone');
      if (this.props.unapprovedFlag) {
        workHourZone = formValues.work_hour_zone;
      }
      const earlyWorkStart = this.state.workTime[workHourZone].overtime_start;
      const overWorkEnd = '';
      const earlyOverTime = {
        fixed_unfixed_type: WORKER_TYPES.contractor.id,
        working_temp_person: SYSTEM_WORKER_COUNT[0].id,
        working_temp_hour: 0.0,
        overtime_start: earlyWorkStart,
        earlytime_end: overWorkEnd,
      };
      formValues.work_over_times = [earlyOverTime];
    } else {
      let workOverTimes = [];
      _.each(data.work_over_times, work_over_time => {
        let over = {
          id: work_over_time.id,
          working_temp_person: work_over_time.working_temp_person,
          working_temp_hour: work_over_time.working_temp_hour,
          overtime_start: work_over_time.overtime_start.slice(0, -3),
          earlytime_end: this.getEarlytimeEnd(
            work_over_time.overtime_start,
            work_over_time.working_temp_hour
          ),
        };
        workOverTimes.push(over);
      });
      formValues.work_over_times = workOverTimes;
    }
    formValues.work_key_plan_image = data.work_key_plan_image
      ? data.work_key_plan_image
      : {};
    formValues.schedule_flag = this.props.isWorkSchedule
      ? SCHEDULE_STATUS.schedule.id
      : SCHEDULE_STATUS.result.id; // 予定フラグ

    if (data.work_key_plan_image) {
      let image = this.state.image;
      image.path = data.work_key_plan_image.img_url;
      image.json = data.work_key_plan_image.layout_json;
      image.keyplanId = data.work_key_plan_image.id;
      this.setState({ image });
    }

    if (!this.props.isWorkHourModal) {
      const spt_field_work_type_id = _.get(data, 'spt_field_work_type.id');
      if (spt_field_work_type_id) {
        formValues.spt_field_work_type_id = _.toString(spt_field_work_type_id);
        pulldownName.spt_main_sub_progress_quanlity_name = _.get(
          data,
          'spt_field_work_type.spt_main_sub_progress_quanlity_name'
        );
      }
    }

    this.setState(
      {
        foremanUserId: data.work_group.foreman_user_id,
        formValues,
        pulldownName,
        isFirstLoaded: true,
        workDayWorkersStatus: work.change_status,
      },
      () => {
        this.checkRequired(formValues);
      }
    );
  }

  /**
   * 必須入力状況チェック (「必須項目の入力数」)
   * @param formValues {object} 入力値
   */
  checkRequired(formValues) {
    let values = {};
    _.map(formValues, (value, index) => {
      if (_.isObject(value)) {
        values[index] = _.isNull(value) ? '' : value;
      } else {
        values[index] = _.isNull(value) ? '' : `${value}`;
      }
    });

    const reqChecked = validateByJoi(this.schema, values);
    const requiredInput = { ...this.state.requiredInput };
    requiredInput.total = requiredInput.columns.length;
    if (!reqChecked.result) {
      requiredInput.count =
        requiredInput.total - Object.keys(reqChecked.messages).length;
    } else {
      requiredInput.count = requiredInput.total;
    }
    this.setState({ requiredInput });
  }

  /**
   * 入力値の有効判定
   */
  validateValue(name = 'all', updateValues = {}) {
    let values = {};
    const validate = _.cloneDeep(this.state.validate);
    const formValues = _.cloneDeep(this.state.formValues);
    _.map(formValues, (value, index) => {
      if (_.isObject(value)) {
        values[index] = _.isNull(value) ? '' : value;
      } else {
        values[index] = _.isNull(value) ? '' : `${value}`;
      }
    });

    const result = validateByJoi(this.schema, values);
    if (name !== 'all') {
      if (_.has(result.messages, name)) {
        // 指定したバリデートに対するエラーが result に入っている場合
        // validate の内容を更新する
        validate.messages[name] = result.messages[name];
      } else if (validate.messages[name]) {
        // 指定したバリデートに対するエラーが result に入っていない場合
        // validate の内容を削除する
        delete validate.messages[name];
      }
    } else if (result.messages) {
      validate.messages = result.messages;
    }

    // 人工の入力欄複数に対して合計人工を求める
    let workersCount = 0;
    _.each(formValues.work_dayworkers, dayworker => {
      workersCount += parseInt(dayworker.working_temp_person);
    });
    const dayWorkerName =
      Number(values.dayworker_type) === WORKER_TYPES.contractor.id
        ? WORKER_TYPES.contractor.name
        : WORKER_TYPES.regular.name;

    if (['all', 'work_date_from', 'work_date_to'].includes(name)) {
      const later = moment(values.work_date_from).add(30, 'days');
      if (moment(values.work_date_to).isAfter(later)) {
        validate.messages.work_date_from = '30日以上は選択できません。';
      } else if (moment(values.work_date_from).isAfter(values.work_date_to)) {
        validate.messages.work_date_from =
          '開始日が終了日より後の日付になっています。';
      } else {
        delete validate.messages.work_date_from;
      }
    }

    if (['all', 'work_dayworkers', 'woman', 'non_japanese'].includes(name)) {
      if (['all', 'work_dayworkers'].includes(name)) {
        if (!_.has(result.messages, 'work_dayworkers')) {
          delete validate.messages.workers;
        } else {
          // result.messages.work_dayworkers オブジェクト内に
          // エラーメッセージが戻ってきているかどうかをチェックする
          let message_workers = '';
          // eslint-disable-next-line no-unused-vars
          for (let [key, value] of Object.entries(
            result.messages.work_dayworkers
          )) {
            message_workers = value;
          }
          validate.messages.workers = message_workers.working_temp_person;
          delete validate.messages.work_dayworkers;
        }
      }

      if (!_.isNaN(workersCount)) {
        if (Number(formValues.woman) > Number(workersCount)) {
          validate.messages.woman = messageUtility.getMessage(
            'E-001-301',
            dayWorkerName
          );
        } else {
          delete validate.messages.woman;
        }

        if (Number(formValues.non_japanese) > Number(workersCount)) {
          validate.messages.non_japanese = messageUtility.getMessage(
            'E-001-302',
            dayWorkerName
          );
        } else {
          delete validate.messages.non_japanese;
        }
      } else {
        delete validate.messages.woman;
        delete validate.messages.non_japanese;
      }
    }

    if (Object.keys(validate.messages).length === 0) {
      validate.invalid = false;
    } else {
      validate.invalid = true;
    }

    this.setState({ validate });
    this.checkRequired(values);
    return Object.keys(validate.messages).length;
  }

  /**
   * 日付選択
   */
  setDate = (name, date) => {
    // console.log('WorkEdit.jsx', 'setDate', name, date);
    if (name !== 'work_date') {
      throw new Error('WorkEdit.jsx setDropdownData');
    }

    const formValues = _.cloneDeep(this.state.formValues);
    if (formValues[name] !== date) {
      formValues[name] = date;
      this.setState({ formValues, workGroupDataUpdateFlag: true }, () => {
        this.updateKeyPlan();
        this.loadReflectWorkTotal();
      });
      if (_.size(this.state.workTimes) === 1) {
        return;
      }
      let workHour = '';
      const sortedWorkHours = _.sortBy(this.state.workTimes, 'start_date');
      workHour = _.last(
        _.filter(sortedWorkHours, w =>
          moment(w.start_date).isSameOrBefore(formValues.work_date)
        )
      );
      if (!workHour) {
        workHour = _.head(
          _.filter(sortedWorkHours, w =>
            moment(w.start_date).isAfter(formValues.work_date)
          )
        );
      }
      const workTime = _.cloneDeep(this.state.workTime);
      workTime[WORK_HOUR_ZONES.day.id].working_time = workHour.worker_work_time;
      workTime[WORK_HOUR_ZONES.night.id].working_time =
        workHour.worker_work_time;
      workTime[WORK_HOUR_ZONES.midnight.id].working_time =
        workHour.worker_work_time;
      this.setState({ workTime });
      if (this.state.isFifteen) {
        // let formValues = this.state.formValues;
        let workingTime =
          workTime[SessionStorageService.getItem('work_hour_zone')].working_time;
        workingTime = moment.duration(workingTime).asHours();
        workingTime = Number(workingTime);
        _.each(formValues.work_dayworkers, workDayworker => {
          if (Number(workDayworker.working_temp_hour) > workingTime) {
            workDayworker.working_temp_hour = workingTime;
          }
          let cur = workDayworker.working_temp_hour / workingTime;
          let rlt = workDayworker.working_temp_person * cur;
          workDayworker.dayworker = rlt.toFixed(2);
        });
        this.setState({ formValues });
      }
      this.checkRequired(formValues);
    }
  };

  /**
   * フォーム入力
   */
  setFlatData = e => {
    // console.log('WorkEdit.jsx setFlatData', e);
    const formValues = _.cloneDeep(this.state.formValues);
    formValues[e.target.name] = deleteControlCode(e.target.value);

    this.setState({ formValues });
  };

  /**
   * ドロップダウン選択
   * @param name {string}
   * @param value {int}
   */
  setDropdownData = (name, value) => {
    // console.log('WorkEdit.jsx', 'setDropdownData', name, value);
    if (
      name === 'field_tree_id' ||
      name === 'job_id' ||
      name === 'foreman_user_id'
    ) {
      this.setState({ workGroupDataUpdateFlag: true });
    }

    this.setState(
      prevState => {
        const formValues = _.cloneDeep(prevState.formValues);
        formValues[name] = deleteControlCode(value);

        // 作業予定/作業実績 の編集画面で
        // 協力会社Dropdownが動作した時に
        // 職種Dropdown 職長Dropdown の初期化が行われる
        // 処理は次の場所で行われている
        //  FieldTreeJob.jsx componentWillReceiveProps
        //  FieldTreeUser.jsx componentWillReceiveProps
        // 不具合[BLDE_V2-17211]として、内部値が更新されていない問題があり
        // この箇所で内部値をクリアしておく

        // 協力会社:field_tree_id
        // 職種:job_id
        // 職長:foreman_user_id

        if (
          name === 'field_tree_id' &&
          this.state.formValues.field_tree_id !== value
        ) {
          // 協力会社に変更があった場合は、職種|職長の値は初期化される
          formValues.job_id = null;
          formValues.foreman_user_id = null;
          formValues.userValueChangeFlag = true;
        } else if (
          name === 'job_id' &&
          this.state.formValues.job_id !== value
        ) {
          // 職種に変更があった場合は、職長の値は初期化される
          formValues.foreman_user_id = null;
          formValues.userValueChangeFlag = true;
        }
        return {
          formValues,
        };
      },
      () => {
        this.validateValue(name);
        if (
          name === 'field_tree_id' ||
          name === 'job_id' ||
          name === 'foreman_user_id'
        ) {
          this.updateKeyPlan();
        }
        if (name === 'field_tree_id') {
          this.loadReflectWorkTotal();
        }
      }
    );
  };

  /**
   * キープラン選択
   *  この関数は
   *    キープランプルダウンで項目を選択した時
   *  に呼び出されます
   *    未選択状態にした時
   *  には呼び出されません。(deleteKeyPlanが呼び出される)
   */
  setDropdownKeyplanData = value => {
    // console.log('WorkEdit.jsx', 'setDropdownKeyplanData', value);

    const image = _.cloneDeep(this.state.image);
    const formValues = _.cloneDeep(this.state.formValues);
    image.path = value.image_url;
    image.json = undefined;
    formValues.work_key_plan_image.key_plan_category_code = value.category_code;
    formValues.work_key_plan_image.edited_image = '';
    formValues.work_key_plan_image.layout_json = undefined;
    this.setState({
      image,
      formValues,
    });
  };

  /**
   * キープラン削除
   *  この関数は、
   *    キープランプルダウンを未選択にする時と
   *    キープラン画像表示時に[x]ボタンをクリックする時
   *  に呼び出されます
   */
  deleteKeyPlan = () => {
    // console.log('WorkEdit.jsx', 'deleteKeyPlan');

    if (this.state.formValues.state_handling_flag) {
      return;
    }
    const state = _.cloneDeep(this.state);
    state.image.path = '';
    state.image.file = '';
    state.image.json = '';
    state.image.keyplanId = '';
    state.image.edited = false;
    state.formValues.work_key_plan_image = {
      key_plan_category_code: '',
      edited_image: '',
    };
    if (this.state.image.keyplanId) {
      state.formValues.work_key_plan_image.id = this.state.image.keyplanId;
    }
    this.setState(state);
  };

  /**
   * キープラン編集フラグ
   */
  setEditKeyplanFlag = () => {
    const image = { ...this.state.image };
    image.edited = true;
    this.setState({ image });
  };

  /**
   * 人工
   * 15分単位で計算
   */
  set15Time = () => {
    if (this.state.formValues.state_handling_flag) {
      return;
    }
    const isFifteen = !this.state.isFifteen;
    let workingTime = '';
    if (isFifteen) {
      workingTime = this.state.workTime[
        SessionStorageService.getItem('work_hour_zone')
      ].working_time;
      workingTime = moment.duration(workingTime).asHours();
      workingTime = Number(workingTime);
    } else {
      workingTime = Number(1).toFixed(2);
    }
    const formValues = _.cloneDeep(this.state.formValues);

    _.each(formValues.work_dayworkers, worker => {
      worker.working_temp_hour = workingTime;
      worker.dayworker =
        !!worker.working_temp_person &&
        Number(worker.working_temp_person).toFixed(2);
    });
    formValues.display_fifteen_minute_flg = !formValues.display_fifteen_minute_flg;
    this.setState(
      {
        isFifteen,
        formValues,
      },
      () => {
        this.validateValue('work_dayworkers');
      }
    );
  };

  /**
   * 人工セット
   */
  setWorkDayTime = (e, key) => {
    const formValues = _.cloneDeep(this.state.formValues);
    let workDayworker = formValues.work_dayworkers[key];
    workDayworker[e.target.name] = e.target.value;
    if (workDayworker.working_temp_person === '') {
      workDayworker.dayworker = '';
    } else {
      if (this.state.isFifteen) {
        let workingTime = this.state.workTime[
          this.state.formValues.work_hour_zone
        ].working_time;
        workingTime = moment.duration(workingTime).asHours();
        let cur = workDayworker.working_temp_hour / workingTime;
        let rlt = workDayworker.working_temp_person * cur;
        workDayworker.dayworker = rlt.toFixed(2);
      } else {
        let rst =
          workDayworker.working_temp_person * workDayworker.working_temp_hour;
        workDayworker.dayworker = rst.toFixed(2);
      }
    }
    formValues.work_dayworkers[key] = workDayworker;
    this.setState({ formValues }, () => {
      this.validateValue('work_dayworkers');
    });
  };

  /**
   * 人工追加
   */
  addWorkDayTime = () => {
    const formValues = _.cloneDeep(this.state.formValues);
    let workingTime = '';
    if (this.state.isFifteen) {
      workingTime = this.state.workTime[
        SessionStorageService.getItem('work_hour_zone')
      ].working_time;
      workingTime = moment.duration(workingTime).asHours();
      workingTime = Number(workingTime);
    } else {
      workingTime = Number(1).toFixed(2);
    }
    const workDayworker = {
      dayworker_type: this.state.formValues.dayworker_type,
      working_temp_person: '',
      working_temp_hour: workingTime,
      dayworker: '',
    };
    formValues.work_dayworkers.push(workDayworker);
    this.setState({ formValues }, () => {
      this.validateValue('work_dayworkers');
    });
  };

  /**
   * 人工削除
   */
  removeWorkDayTime = key => {
    const formValues = _.cloneDeep(this.state.formValues);
    let workDayworkers = [];
    _.each(formValues.work_dayworkers, (work_dayworker, index) => {
      if (index !== key) {
        workDayworkers.push(work_dayworker);
      }
    });
    formValues.work_dayworkers = workDayworkers;
    this.setState({ formValues }, () => {
      this.validateValue('work_dayworkers');
    });
  };

  /**
   * 残業早出入力
   * @param key {string}
   * @param name {string}
   * @param flag {int} // 早出残業フラグ
   */
  setEarlyOverTime = (e, key, name, flag) => {
    let workHourZone = SessionStorageService.getItem('work_hour_zone');
    const formValues = _.cloneDeep(this.state.formValues);
    if (this.props.unapprovedFlag) {
      workHourZone = formValues.work_hour_zone;
    }
    let workEarlyOverTime = formValues[name][key];
    workEarlyOverTime[e.target.name] = e.target.value;
    if (flag === WORK_EARLY_OVER_TYPES.early.id) {
      workEarlyOverTime.overtime_start = this.getOvertimeStart(
        this.state.workTime[workHourZone].earlytime_end,
        workEarlyOverTime.working_temp_hour
      );
    } else if (WORK_EARLY_OVER_TYPES.over.id) {
      workEarlyOverTime.earlytime_end = this.getEarlytimeEnd(
        this.state.workTime[workHourZone].overtime_start,
        workEarlyOverTime.working_temp_hour
      );
    }
    formValues[name][key] = workEarlyOverTime;
    this.setState({ formValues });
  };

  /**
   * 早出開始時間を計算
   * @param earlytimeEnd {string}
   * @param tempHour {string}
   */
  getOvertimeStart(earlytimeEnd, tempHour) {
    let start = new Date(`2016/01/01 ${earlytimeEnd}`);
    var hour = parseFloat(tempHour);
    let end = new Date(start.getTime() - hour * 60 * 60 * 1000);
    let result = `${`000${end.getHours()}`.slice(
      -2
    )}:${`00${end.getMinutes()}`.substr(
      `00${end.getMinutes()}`.length - 2,
      2
    )}`;
    return result;
  }

  /**
   * 残業終了時間を計算
   * @param overtimeStart {string}
   * @param tempHour {string}
   */
  getEarlytimeEnd(overtimeStart, tempHour) {
    let start = new Date(`2016/01/01 ${overtimeStart}`);
    var hour = parseFloat(tempHour);
    let end = new Date(start.getTime() + hour * 60 * 60 * 1000);
    let result = `${`000${end.getHours()}`.slice(
      -2
    )}:${`00${end.getMinutes()}`.substr(
      `00${end.getMinutes()}`.length - 2,
      2
    )}`;
    return result;
  }

  /**
   * 早出残業追加
   * @param name {string}
   */
  addEarlyOverTime = name => {
    const formValues = _.cloneDeep(this.state.formValues);
    let workHourZone = SessionStorageService.getItem('work_hour_zone');
    if (this.props.unapprovedFlag) {
      workHourZone = formValues.work_hour_zone;
    }
    const earlyWorkStart =
      name === 'work_over_times'
        ? this.state.workTime[workHourZone].overtime_start
        : '';
    const overWorkEnd =
      name === 'work_early_times'
        ? this.state.workTime[workHourZone].earlytime_end
        : '';
    const earlyOverTime = {
      fixed_unfixed_type: WORKER_TYPES.contractor.id,
      working_temp_person: SYSTEM_WORKER_COUNT[0].id,
      working_temp_hour: 0.0,
      overtime_start: earlyWorkStart,
      earlytime_end: overWorkEnd,
    };
    formValues[name].push(earlyOverTime);
    this.setState({ formValues });
  };

  /**
   * 早出残業削除
   * @param key {string} index
   * @param name {string}
   */
  removeEarlyOverTime = (key, name) => {
    const formValues = _.cloneDeep(this.state.formValues);
    let workEarlyOverTimes = [];
    _.each(formValues[name], (workEarlyOverTime, index) => {
      if (index !== key) {
        workEarlyOverTimes.push(workEarlyOverTime);
      }
    });
    formValues[name] = workEarlyOverTimes;
    this.setState({ formValues });
  };

  /**
   * 削除
   */
  async deleteWorkSchedule(check) {
    if (this.updatingFlag) {
      return;
    }
    this.updatingFlag = true;

    let checkBeforeDeletingWorkMessage = null;
    if (check && this.props.isWorkSchedule) {
      await WorkScheduleService.checkBeforeDeletingWork(
        this.state.fieldId,
        this.state.scheduleId
      ).then(response => {
        checkBeforeDeletingWorkMessage = response.message;
      });
    }
    if (checkBeforeDeletingWorkMessage) {
      this.updatingFlag = false;
      this.setState({ isShowPopupCheckBeforeDeletingWork: true, checkBeforeDeletingWorkMessage });
    } else {
      WorkScheduleService.deleteSchedule(
        this.state.fieldId,
        this.state.scheduleId
      ).then(response => {
        if (response.result) {
          _slideLoader.close(this.props.vw);
          EventMg.trigger(MY_EVENT.LOAD_GROUP_DATA);
        }
      }).finally(() => {
        this.updatingFlag = false;
      });
    }
  }

  /**
   * 中止
   */
  abortWorkSchedule() {
    WorkScheduleService.abort(this.state.fieldId, this.state.scheduleId).then(
      response => {
        if (response.result) {
          _slideLoader.close(this.props.vw);
          EventMg.trigger(MY_EVENT.LOAD_GROUP_DATA);
        }
      }
    );
  }

  /**
   * 中止解除
   */
  resumeWorkSchedule() {
    WorkScheduleService.resume(this.state.fieldId, this.state.scheduleId).then(
      response => {
        if (response.result) {
          _slideLoader.close(this.props.vw);
          EventMg.trigger(MY_EVENT.LOAD_GROUP_DATA);
        }
      }
    );
  }

  /**
   * 更新
   * @param continuity {bool}
   */
  eventUpdate = () => {
    // console.log('WorkEdit.jsx eventUpdate', this.state.formValues);

    if (this.updatingFlag) {
      return;
    }
    this.updatingFlag = true;
    // キープラン画像変更なし && workGroupIdの変更なしの時false
    let includeWorkKeyPlanImageKey = true;

    const formValues = _.cloneDeep(this.state.formValues);
    const listMessageConcurrentException = [
      '（大工種）が必須です。',
      '場所が必須です。',
    ];
    formValues.display_fifteen_minute_flg = this.state.isFifteen;
    this.setState({
      formValues,
    });

    let validate = this.validateValue();
    if (validate !== 0) {
      this.updatingFlag = false;
      return;
    }

    let param = _.cloneDeep(this.state.formValues);

    if (this.props.isWorkBatchEdit) {
      //Temporary update row data, do not call submitting
      param = this.checkEarlyOverTimes(_.pick(param, WORK_HOUR_KEYS));
      this.props.onUpdate(param);
      return;
    }

    // console.log('WorkEdit.jsx eventUpdate 1', param.work_key_plan_image.layout_json);
    if (_.has(param, 'work_key_plan_image.layout_json.objects')) {
      // console.log(
      //   'WorkEdit.jsx eventUpdate 1-1 キープラン選択 編集',
      //   param.work_key_plan_image
      // );
      param.work_key_plan_image.is_not_update = false;
    } else if (
      param.work_key_plan_image.key_plan_category_code === '' ||
      _.isUndefined(param.work_key_plan_image.key_plan_category_code)
    ) {
      // console.log('WorkEdit.jsx eventUpdate 1-2 キープラン未選択');

      // WorkGroupに対する結合時にキープランを上書きしてほしくないので
      // 画像を更新しないフラグを有効にする
      // BLDE_V2-18193 のコメント欄で 2020/04/17 に話されている内容による
      if (this.state.workGroupDataUpdateFlag === true) {
        param.work_key_plan_image.is_not_update = true;
      } else {
        param.work_key_plan_image.is_not_update = false;
      }
      param.work_key_plan_image.layout_json = null;
      param.work_key_plan_image.edited_image = null;
    } else if (_.isUndefined(param.work_key_plan_image.layout_json)) {
      // console.log('WorkEdit.jsx eventUpdate 1-3 キープラン選択 切替');

      // キープランを選択して編集していない場合
      // 編集したデータが残っている場合があるので、
      // 下記のパラメータはクリアする
      param.work_key_plan_image.is_not_update = false;
      param.work_key_plan_image.layout_json = null;
      param.work_key_plan_image.edited_image = null;
    } else {
      // console.log('WorkEdit.jsx eventUpdate 1-4 キープラン選択 未切替 未編集');

      // 画面が開いた際にデータを読み出して
      // 画像+オブジェクトがデータにあるのに、オブジェクトを編集しなかった場合
      // また、人工ダイアログから呼び出された場合

      // 画像を更新しないフラグを有効にする
      // オブジェクト編集されていない場合には layout_json の読み込みがなく
      // そのまま上書きされるため。
      // BLDE_V2-18193 のコメント欄で 2020/04/14 以前で話されている内容による
      param.work_key_plan_image.is_not_update = true;
      param.work_key_plan_image.layout_json = null;
      param.work_key_plan_image.edited_image = null;

      if (this.state.workGroupDataUpdateFlag === true) {
        includeWorkKeyPlanImageKey = true;
      } else {
        includeWorkKeyPlanImageKey = false;
      }
    }
    // is_not_update = true に設定している箇所は
    // API的には
    // layout_json と edited_image に null を設定する必要ないはずだが
    // 念の為に null 設定している

    // console.log(
    //   'WorkEdit.jsx eventUpdate 2',
    //   param.work_key_plan_image.layout_json
    // );

    if (!_.isBoolean(param.work_key_plan_image.is_not_update)) {
      throw new Error('WorkEdit.jsx eventUpdate is_not_update unset');
    }

    if (!this.state.isShowMainSubDropdown) {
      param.main_work_type_id = param.sub_work_type_id = null;
    }

    if (!this.props.isWorkHourModal) {
      if (!this.state.isShowSptDropdown || !param.spt_field_work_type_id) {
        param.spt_field_work_type_id = 0; //delete spt_field_work_type_id of work
      }
    }

    param = this.checkEarlyOverTimes(param);

    /**
     * キープラン画像の変更、編集、削除がなく、work_group_idも変化していない時は
     * work_key_plan_imageを更新のパラメーターから除外する(サーバー側で不要な画像更新を避けるため)
     *
     * 緊急対応可能なようis_not_updateのロジックはそのまま残す必要がある
     * is_not_updateと似通っていて将来的には統一が必要だが現時点では両方必要
     */
    if (!includeWorkKeyPlanImageKey) {
      delete param.work_key_plan_image;
    }
    // 編集画面からの呼び出し時のみ必要なパラメーター
    if (!this.props.isWorkHourModal) {
      param.from_work_edit = 1;
    }

    if (!this.state.requiredInput.columns.includes('sub_work_type_id')) {
      param.sub_work_type_id = null;
    }

    WorkScheduleService.update(this.state.fieldId, this.state.scheduleId, param)
      .then(response => {
        // API の戻り値について
        //  正常系：response.result === true
        //  異常系：response.data.result === false
        // エラー時は response.status が 400 等になる。
        // request.js で error オブジェクトを返しているため。
        // 正常時は status が 0 になる。
        if (response.status === 400) {
          if (response.data.message.includes('人工は必須')) {
            this.showErrorDialog(response.data.message);
            const validate = { ...this.state.validate };
            validate.messages.work_date_from = response.data.message;
            validate.invalid = true;
            this.setState({ validate });
            return;
          } else if (
            _.includes(listMessageConcurrentException, response.data.message)
          ) {
            this.setState({
              isShowPopupError: true,
            });
          } else if (!response.data.result) {
            if (
              isPrimeContractorHasBlockedOrFinishedWorkError(
                response.data.message
              )
            ) {
              return dialogLoader.show(FormInformationDialog, {
                title: messageUtility.getMessage('E-001-422'),
                message: messageUtility.getMessage('E-001-423'),
                onClose: () => {
                  window.location.reload();
                },
              });
            } else if (
              response.data.message === messageUtility.getMessage('E-000-073')
            ) {
              return dialogLoader.show(CancelAndConfirmDialog, {
                title: messageUtility.getMessage('E-001-402'),
                message: response.data.message,
                confirmButtonText: messageUtility.getMessage('I-000-180'),
                cancelButtonText: messageUtility.getMessage('I-000-017'),
                effectiveButtonClassName: 'btn',
                onCancel: () => {
                  dialogLoader.close();
                },
                onConfirm: () => {
                  window.location.reload();
                },
              });
            }
            return this.showErrorDialog(response.data.message);
          }
        }

        if (response.result) {
          // 作業一覧から人工ダイアログで編集した場合はスライドはないので親から与えられたonUpdateを実行する
          if (this.props.isWorkHourModal) {
            this.props.onUpdate();
            return;
          }
          // 一覧画面へ
          _slideLoader.close(this.props.vw);
          EventMg.trigger(MY_EVENT.LOAD_GROUP_DATA);
        }
      })
      .finally(() => {
        this.updatingFlag = false;
        // 人工ダイアログが閉じた後にsetStateが走らないようにするため
        if (!this.props.isWorkHourModal) {
          this.setState({ workGroupDataUpdateFlag: false });
        }
      });
  };

  /**
   * 酸欠帳票出力
   */
  callDocurain() {
    const date = SessionStorageService.getItem('date_from');
    let param = {};
    param.field_id = this.state.fieldId;
    param.work_hour_zone = SessionStorageService.getItem('work_hour_zone');
    param.target_date = moment(date).format('YYYY-MM-DD');
    param.foreman_user_id = this.state.foremanUserId;
    param.file_code = 2;
    param.report_code = 17;
    const reportName = ReportNames.AllOxygenLackPartnerCompany;
    const newTab = window.open('/LayoutPrint', '_blank');
    PrintService.printReportByReportName(reportName, param)
      .then(async response => {
        const targetDate = moment(this.state.targetDate).format('YYYY/MM/DD');
        const fileName = PrintService.makeReportFileName(
          reportName,
          param.file_code,
          targetDate
        );
        let blob;
        if (_.isUndefined(response.message)) {
          const pdfUrl = response.pdf_s3_url;
          await PrintService.getHeaderReponseURL(pdfUrl.head_pdf_url)
            .then(responseS3AWS => {
              if (responseS3AWS.status === STATUS_CODE.ok) {
                blob = PrintUtility.convertBase64ToBlob(
                  response.data,
                  'application/pdf'
                );
                newTab.location.href = pdfUrl.get_pdf_url;
              }
            })
            .catch(error => {
              newTab.close();
              let result = {
                result: false,
                status: error.status,
                message: messageUtility.getMessage('E-001-401'),
              };
              blob = new Blob([JSON.stringify(result)], {
                type: 'application/json',
              });
            });
        } else {
          newTab.close();
          blob = new Blob([JSON.stringify(response)], {
            type: 'application/json',
          });
        }
        PrintUtility.printBlob(blob, fileName, param.file_code);
        this.setState({ calling: false });
      })
      .catch(error => {
        newTab.close();
        this.setState({ calling: false });
        alert(error);
      });
  }

  /**
   * 早出残業入力チェック
   * 0の場合POSTしない
   */
  checkEarlyOverTimes(formValues) {
    // 分割代入
    let { work_early_times: early, work_over_times: over } = formValues;
    let earlyTimes = [];
    _.each(early, time => {
      if (
        _.isInteger(time.id) ||
        (time.working_temp_hour > 0 && time.working_temp_person > 0)
      ) {
        earlyTimes.push(time);
      }
    });
    let overTimes = [];
    _.each(over, time => {
      if (
        _.isInteger(time.id) ||
        (time.working_temp_hour > 0 && time.working_temp_person > 0)
      ) {
        overTimes.push(time);
      }
    });
    formValues.work_early_times = earlyTimes;
    formValues.work_over_times = overTimes;
    return formValues;
  }

  keyplanObserver() {
    const formValues = _.cloneDeep(this.state.formValues);
    const key_plan = { ...this.state.formValues.work_key_plan_image };
    key_plan.edited_image = document.getElementById('keyplan-image-val').value;
    key_plan.layout_json = JSON.parse(
      document.getElementById('keyplan-image-obj').value
    );
    formValues.work_key_plan_image = key_plan;
    // console.log('WorkEdit.jsx', 'keyplanObserver',
    //   document.getElementById('keyplan-image-val').value,
    //   document.getElementById('keyplan-image').src,
    //   key_plan.layout_json,
    // );

    // 現場配置画面での編集後のキープラン画像設定が切り替わらないためにここで修正する
    const image = _.cloneDeep(this.state.image);
    image.path = key_plan.edited_image;
    image.json = key_plan.layout_json;
    this.setState({ formValues, image });
  }
  /* eslint-enable prettier/prettier */

  // getKeyPlanDataByCategoryCodeで使用のため
  setLoadedKeyPlanData(keyPlanData) {
    this.setState({
      loadedKeyPlanData: keyPlanData,
    });
  }

  checkClearValidate = () => {
    const keyMessagesPlace = KEY_MESSAGES_REQUIRE_INPUT_PLACE;
    let messages = _.cloneDeep(this.state.validate.messages);
    const newKeyMessages = _.filter(Object.keys(messages), item => {
      return keyMessagesPlace.includes(item);
    });
    if (_.isEmpty(newKeyMessages)) {
      return;
    }
    _.forEach(newKeyMessages, key => {
      delete messages[key];
    });
    this.setState({
      validate: {
        invalid: !_.isEmpty(messages),
        messages,
        validated: !_.isEmpty(messages),
      },
    });
  };

  checkClearRequireInput = () => {
    const requireColumns = KEY_MESSAGES_REQUIRE_INPUT_PLACE;
    const columnsRequiredInput = _.cloneDeep(this.state.requiredInput.columns);
    const columns = _.filter(columnsRequiredInput, item => {
      return !_.includes(requireColumns, item);
    });
    this.setState(
      {
        requiredInput: {
          ...this.state.requiredInput,
          columns,
        },
      },
      () => {
        this.checkRequired(this.state.formValues);
      }
    );
  };

  setVisibleMainSubWorkDropdown = work_date => {
    const formValues = _.cloneDeep(this.state.formValues);
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    const progressDateFrom = moment(this.state.progress_date_from);
    const progressDateTo = moment(this.state.progress_date_to);
    const workDate = moment(work_date);

    formValues.work_date = work_date;
    if (
      !progressDateFrom.isValid() ||
      (!progressDateTo.isValid() && workDate.isBefore(progressDateFrom)) ||
      workDate.isBefore(progressDateFrom) ||
      progressDateTo.isBefore(workDate) ||
      this.state.lengthOfListMainWorkTypes === 0
    ) {
      if (this.state.isShowMainSubDropdown) {
        formValues.workPlaceRequireType = null;
        formValues.isMainTypeRequired = false;
        formValues.isSubTypeRequired = false;
        this.setState(
          {
            formValues,
            isShowMainSubDropdown: false,
          },
          () => {
            this.checkClearRequireInput();
            this.checkClearValidate();
          }
        );
      }
    } else {
      if (!this.state.isShowMainSubDropdown) {
        if (!_.includes(requiredInput.columns, 'main_work_type_id')) {
          requiredInput.columns.push('main_work_type_id');
        }
        formValues.isMainTypeRequired = true;
        formValues.workPlaceRequireType = this.temporaryWorkPlaceRequireType;
        if (!_.isNull(formValues.sub_work_type_id)) {
          if (!_.includes(requiredInput.columns, 'sub_work_type_id')) {
            requiredInput.columns.push('sub_work_type_id');
          }
          formValues.isSubTypeRequired = true;
        }
        const workRequire = this.setNewWorkPlaceRequireInput(
          this.temporaryWorkPlaceRequireType
        );
        _.forEach(workRequire, value => {
          requiredInput.columns.push(value);
        });
        this.setState(
          {
            formValues,
            requiredInput,
            isShowMainSubDropdown: true,
          },
          () => {
            this.checkRequired(this.state.formValues);
          }
        );
      }
    }
  };

  loadReflectWorkTotal = () => {
    const { checkInReflectToResultFlag, formValues } = this.state;
    if (
      this.props.isWorkSchedule ||
      !checkInReflectToResultFlag ||
      formValues.work_hour_zone.toString() !== WORK_HOUR_ZONES.day.key
    ) {
      return;
    }

    const { work_date, field_tree_id } = this.state.formValues;
    WorkScheduleService.getCountReflectWork(this.fieldId, {
      field_tree_id,
      work_date,
    }).then(response => {
      this.setState({
        reflectWorkTotal: _.get(
          response,
          'data.entities.number_of_reflect_work',
          0
        ),
      });
    });
  };

  getSptLinkageSetting = (work_date) => {
    SptService.getSptLinkageSetting(this.state.fieldId).then(response => {
      const sptLinkageSetting = _.get(response, 'data.entities.spt_linkage_setting') || {};
      this.setState(
        {
          sptDateFrom: sptLinkageSetting.linkage_start_date || null,
          sptDateTo: sptLinkageSetting.linkage_end_date || null,
        },
        () => this.setVisibleSptDropdown(work_date)
      );
    });
  }

  setVisibleSptDropdown = (work_date) => {
    const sptDateFrom = moment(this.state.sptDateFrom);
    if (!sptDateFrom.isValid()) {
      return;
    }
    const sptDateTo = moment(this.state.sptDateTo);
    const workDate = moment(work_date);
    const isHidden =
      sptDateFrom.isAfter(workDate) || sptDateTo.isBefore(workDate);
    this.setState({
      isShowSptDropdown: !isHidden,
    });
  };

  setWorkDate = date => {
    this.setVisibleMainSubWorkDropdown(date);
    this.setVisibleSptDropdown(date);
  };

  setNewWorkPlaceRequireInput = workPlaceRequireType => {
    let listRequireWorkPlace = [];
    _.forEach(workPlaceRequireType, key => {
      switch (key) {
        case NUMBER_OF_FIELD_ITEM_TYPE.itemA:
          listRequireWorkPlace.push(REQUIRE_WORK_PLACE[0]);
          break;
        case NUMBER_OF_FIELD_ITEM_TYPE.itemB:
          listRequireWorkPlace.push(REQUIRE_WORK_PLACE[1]);
          break;
        case NUMBER_OF_FIELD_ITEM_TYPE.itemC:
          listRequireWorkPlace.push(REQUIRE_WORK_PLACE[2]);
          break;
        case NUMBER_OF_FIELD_ITEM_TYPE.itemD:
          listRequireWorkPlace.push(REQUIRE_WORK_PLACE[3]);
          break;
        default:
          break;
      }
    });
    return listRequireWorkPlace;
  };

  setValueMainWorkTypes = (id, name = null, requirePlace = null) => {
    const selectedMainWork = _.find(
      this.state.listMainWorkTypes,
      item => item.main_work_type_id === parseInt(id)
    );
    let requiredItemListId;
    const formValues = _.cloneDeep(this.state.formValues);

    if (selectedMainWork) {
      formValues.main_work_type_name = selectedMainWork.name;
      requiredItemListId = selectedMainWork.required_item_list_ids;
    } else {
      requiredItemListId = requirePlace;
      formValues.main_work_type_name = name;
    }
    formValues.main_work_type_id = !_.isNull(id) ? parseInt(id) : null;
    formValues.sub_work_type_id = null;
    formValues.sub_work_type_name = null;
    this.temporaryWorkPlaceRequireType = requiredItemListId;
    this.setState(
      {
        formValues,
        keySubWork: this.state.keySubWork + 1,
        keyMainWork: this.state.keyMainWork + 1,
        listSubWorkTypes: [],
      },
      () => {
        this.checkClearValidate();
        this.checkRequired(this.state.formValues);
      }
    );
  };

  setValueSubWorkTypes = (id, name = null, requirePlace = null) => {
    const selectedSubWork = _.find(
      this.state.listSubWorkTypes,
      item => item.sub_work_type_id === parseInt(id)
    );
    let workPlaceType = null;
    const requiredInput = _.cloneDeep(this.state.requiredInput);
    const columns = _.filter(
      requiredInput.columns,
      item => !_.includes(REQUIRE_WORK_PLACE, item)
    );
    let workPlaceRequireType;
    let sub_work_type_name;

    if (selectedSubWork) {
      workPlaceType = selectedSubWork.required_item_list_ids;
      if (workPlaceType) {
        const newColumnRequireInput = this.setNewWorkPlaceRequireInput(
          workPlaceType
        );
        requiredInput.columns = [...columns, ...newColumnRequireInput];
        workPlaceRequireType = workPlaceType;
      } else {
        requiredInput.columns = columns;
        workPlaceRequireType = null;
      }
      sub_work_type_name = selectedSubWork.name;
    } else {
      sub_work_type_name = name;
      workPlaceRequireType = requirePlace;
    }
    if (!_.isUndefined(workPlaceRequireType)) {
      this.temporaryWorkPlaceRequireType = workPlaceRequireType;
    }

    this.setState(
      prevState => ({
        formValues: {
          ...prevState.formValues,
          workPlaceRequireType: _.isUndefined(workPlaceRequireType)
            ? prevState.formValues.workPlaceRequireType
            : workPlaceRequireType,
          sub_work_type_name: _.isUndefined(sub_work_type_name)
            ? prevState.formValues.sub_work_type_name
            : sub_work_type_name,
          sub_work_type_id: !_.isNull(id) ? parseInt(id) : null,
        },
        requiredInput,
        keySubWork: this.state.keySubWork + 1,
      }),
      () => {
        this.checkClearValidate();
        this.checkRequired(this.state.formValues);
      }
    );
  };

  getListMainWorkTypesData = response => {
    const totalData = _.get(response, 'data.total') || 0;
    const newMainWorkData =
      _.get(response, 'data.entities.field_main_work_types') || [];
    this.setState({
      listMainWorkTypes: [...this.state.listMainWorkTypes, ...newMainWorkData],
      lengthOfListMainWorkTypes: totalData,
    });
  };

  getListSubWorkTypesData = response => {
    const newSubWorkData =
      _.get(response, 'data.entities.field_sub_work_types') || [];
    this.setState(
      {
        listSubWorkTypes: [...this.state.listSubWorkTypes, ...newSubWorkData],
      },
      () => {
        this.setValidateSubWorkAndPlaces();
      }
    );
  };

  setValidateSubWorkAndPlaces = () => {
    this.setState(
      prevState => {
        const requiredInput = _.cloneDeep(prevState.requiredInput);
        const requireItem = _.cloneDeep(this.temporaryWorkPlaceRequireType);
        requiredInput.columns = _.filter(
          requiredInput.columns,
          item => !_.includes(CONST_ABCD__PLACE_AND_SUB_WORK, item)
        );
        let isSubTypeRequired = false;
        const workRequirePlace = this.setNewWorkPlaceRequireInput(requireItem);
        _.forEach(workRequirePlace, value => {
          requiredInput.columns.push(value);
        });
        if (!_.isEmpty(this.state.listSubWorkTypes)) {
          if (!_.includes(requiredInput.columns, 'sub_work_type_id')) {
            requiredInput.columns.push('sub_work_type_id');
          }
          isSubTypeRequired = true;
        }
        return {
          formValues: {
            ...this.state.formValues,
            isSubTypeRequired,
            workPlaceRequireType: requireItem,
          },
          requiredInput,
        };
      },
      () => {
        this.checkClearValidate();
        this.checkRequired(this.state.formValues);
      }
    );
  };

  // loadedKeyPlanDataに該当データがあればそれを返し、なければAPIから検索する
  async getKeyPlanDataByCategoryCode(categoryCode) {
    const searchFromLoadedKeyPlanData = this.state.loadedKeyPlanData.find(
      item => item.category_code === categoryCode
    );
    if (searchFromLoadedKeyPlanData) {
      return searchFromLoadedKeyPlanData;
    }
    const searchParams = {
      field_id: this.state.fieldId,
      limit: 100,
      category_code: categoryCode,
    };
    const keyPlanByCategoryCodeResponse = await FieldImageService.keyplan(
      this.state.fieldId,
      searchParams
    );
    if (keyPlanByCategoryCodeResponse.result) {
      const keyPlanDataByCategoryCode =
        keyPlanByCategoryCodeResponse.data.entities.field_images[0];
      return keyPlanDataByCategoryCode;
    }
    return false;
  }

  /**
   * workGroupId変更時(日付、協力会社、職種、職長のいずれか変更)、
   * workGroupIdに紐づくkeyplan画像があればデータをセットし、なければクリアする
   */
  async updateKeyPlan() {
    const {
      work_date,
      field_tree_id,
      job_id,
      foreman_user_id,
      schedule_flag,
    } = this.state.formValues;

    // workGroupIdが決定できる時のみ実行する
    if (!work_date || !field_tree_id || !job_id || !foreman_user_id) {
      return;
    }

    const workHourZone = SessionStorageService.getItem('work_hour_zone');
    const existingKeyPlanResponse = await WorkScheduleService.getKeyPlanImage({
      fieldId: this.state.fieldId,
      fieldTreeId: field_tree_id,
      foremanUserId: foreman_user_id,
      jobId: job_id,
      workDate: work_date,
      workHourZone,
      scheduleFlag: schedule_flag,
    });
    if (existingKeyPlanResponse.result) {
      const workKeyPlanImage =
        existingKeyPlanResponse.data.entities.work_key_plan_image;

      // workGroupIdに紐づくkeyplan画像がない場合はデータをクリアする
      if (workKeyPlanImage === null) {
        this.setState({
          image: {
            edited: false,
            json: '',
            keyplanId: '',
            path: '',
          },
          formValues: {
            ...this.state.formValues,
            work_key_plan_image: {},
          },
        });
        return;
      }

      let workKeyPlanState;
      // キープラン画像登録はあるが未編集の場合はedited_imageがnull
      if (workKeyPlanImage.edited_image === null) {
        const data = await this.getKeyPlanDataByCategoryCode(
          workKeyPlanImage.key_plan_category_code
        );
        workKeyPlanState = {
          path: data.image_url,
          json: null,
          edited: false,
          keyplanId: data.id,
        };
      } else {
        workKeyPlanState = {
          path: workKeyPlanImage.img_url,
          json: workKeyPlanImage.layout_json,
          keyplanId: workKeyPlanImage.id,
          edited: false,
        };
      }
      this.setState({
        image: workKeyPlanState,
        formValues: {
          ...this.state.formValues,
          work_key_plan_image: workKeyPlanImage,
        },
      });
    }
  }

  closeConfirmDialog = () => {
    this.setState({
      isShowPopupError: false,
    });
  };

  closeConfirmDialogCheckBeforeDeletingWork = () => {
    this.setState({
      isShowPopupCheckBeforeDeletingWork: false,
    });
  };

  showErrorDialog(message) {
    dialogLoader.show(FormInformationDialog, {
      message,
      onClose: () => {
        dialogLoader.close();
      },
      buttonText: messageUtility.getMessage('I-000-008'),
      buttonClassName: 'btn--sm--sub',
      multilineText: false,
    });
  }

  getWorkDayWorkerDescription = () => (
    <div className='work-day-worker__right-component'>
      <span className='work-day-worker__initial'>初期：黒</span>
      <span className='work-day-worker__manual'>
        <span>入場人数自動反映：</span>
        <span className='text--positive'>青</span>
      </span>
      <span>手動登録：</span>
      <span className='text--red--primary'>赤</span>
    </div>
  );

  render() {
    const {
      checkInReflectToResultFlag,
      reflectWorkTotal,
      workDayWorkersStatus,
      isShowSptDropdown,
    } = this.state;
    const isDisplayDayWorkerDescription =
      checkInReflectToResultFlag && !this.props.isWorkSchedule;

    // 人工モーダル表示時は人工フォームと戻る、保存するボタンだけをレンダリングする
    if (this.props.isWorkHourModal) {
      return (
        <div className='dialog dialog--modal WorkHoursModal WorkResultEdit'>
          <div className='dialog__header'>
            <span className='dialog__title'>人工</span>
            {isDisplayDayWorkerDescription &&
              this.getWorkDayWorkerDescription()}
          </div>
          <div className='dialog__body'>
            {this.state.isWorkHourModalLoaded ? (
              <WorkScheduleForm
                companyItemOrders={this.state.companyItemOrders}
                companyItemSettings={this.state.companyItemSettings}
                values={this.state.formValues}
                isEdit={true}
                errors={this.state.validate.messages}
                workTime={this.state.workTime}
                isFifteen={this.state.isFifteen}
                roleId={this.state.roleId}
                image={this.state.image.path}
                imageJson={this.state.image.json}
                aborted={this.state.formValues.state_handling_flag}
                approved={this.state.approvedFlag}
                partnerCompanyApprovalFlag={
                  this.state.partnerCompanyApprovalFlag
                }
                usePartnerCompanyApprovalFlag={
                  this.state.usePartnerCompanyApprovalFlag
                }
                fieldItem={this.state.fieldItem}
                events={this.events}
                isWorkHourModal={this.props.isWorkHourModal}
                keyplanObserver={this.keyplanObserver.bind(this)}
                setLoadedKeyPlanData={this.setLoadedKeyPlanData}
                setValueMainWorkTypes={this.setValueMainWorkTypes}
                setValueSubWorkTypes={this.setValueSubWorkTypes}
                setWorkDate={this.setWorkDate}
                isShowMainSubDropdown={this.state.isShowMainSubDropdown}
                keySubWork={this.state.keySubWork}
                onLoadDataMain={this.getListMainWorkTypesData}
                keyMainWork={this.state.keyMainWork}
                onLoadDataSub={this.getListSubWorkTypesData}
                isWorkSchedule={this.props.isWorkSchedule}
                reflectWorkTotal={reflectWorkTotal}
                workDayWorkersStatus={workDayWorkersStatus}
                checkInReflectToResultFlag={checkInReflectToResultFlag}
              />
            ) : (
              <div className='indicator' />
            )}
          </div>
          <div className='dialog__footer'>
            <button
              id='modal-close-jinkou-input'
              className='btn--sub'
              onClick={() => {
                this.props.onClose();
              }}
            >
              閉じる
            </button>
            <button
              className='btn--effective'
              onClick={() => {
                this.events.form.update();
              }}
              disabled={this.updatingFlag ? 'disabled' : ''}
            >
              保存
            </button>
          </div>
        </div>
      );
    }

    const createPageTitle = ({
      approvedFlag,
      partnerCompanyApprovalFlag,
      isWorkSchedule,
    }) => {
      let pageTitle = '';
      if (approvedFlag) {
        pageTitle += `承認済作業`;
        pageTitle += isWorkSchedule ? '予定' : '実績';
        if (partnerCompanyApprovalFlag) {
          pageTitle += '編集';
        }
      } else {
        pageTitle += isWorkSchedule ? '作業予定編集' : '作業実績編集';
      }
      return pageTitle;
    };
    const pageTitle = createPageTitle({
      approvedFlag: this.state.approvedFlag,
      partnerCompanyApprovalFlag: this.state.partnerCompanyApprovalFlag,
      isWorkSchedule: this.props.isWorkSchedule,
    });

    return (
      <div className='slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.conference} - {pageTitle}
          </title>
        </Helmet>
        <div className='slide-view__view'>
          <WorkScheduleRegisterHeader
            callbacks={this.events}
            approvedFlag={this.state.approvedFlag}
            partnerCompanyApprovalFlag={this.state.partnerCompanyApprovalFlag}
            stateHandlingFlag={this.state.formValues.state_handling_flag}
            oxygenLackPrintFlag={this.state.fieldItem.oxygen_lack_print_flag}
            isExistOxygenLack={this.state.isExistOxygenLack}
            validate={this.state.validate}
            isWorkSchedule={this.props.isWorkSchedule}
            unapprovedFlag={this.props.unapprovedFlag}
            loaded={this.state.loaded}
            pageTitle={pageTitle}
            requiredInput={this.state.requiredInput}
            vw={this.props.vw}
          />
          <WorkScheduleForm
            companyItemOrders={this.state.companyItemOrders}
            companyItemSettings={this.state.companyItemSettings}
            values={this.state.formValues}
            isEdit={true}
            errors={this.state.validate.messages}
            workTime={this.state.workTime}
            isFifteen={this.state.isFifteen}
            roleId={this.state.roleId}
            image={this.state.image.path}
            imageJson={this.state.image.json}
            aborted={this.state.formValues.state_handling_flag}
            approved={this.state.approvedFlag}
            partnerCompanyApprovalFlag={this.state.partnerCompanyApprovalFlag}
            usePartnerCompanyApprovalFlag={
              this.state.usePartnerCompanyApprovalFlag
            }
            partnerApprovalName={this.state.partnerApprovalName}
            isFirstLoaded={this.state.isFirstLoaded}
            fieldItem={this.state.fieldItem}
            pulldownName={this.state.pulldownName}
            events={this.events}
            keyplanObserver={this.keyplanObserver.bind(this)}
            options={this.state.options}
            loaded={this.state.loaded}
            setLoadedKeyPlanData={this.setLoadedKeyPlanData}
            setValueMainWorkTypes={this.setValueMainWorkTypes}
            setValueSubWorkTypes={this.setValueSubWorkTypes}
            setWorkDate={this.setWorkDate}
            isShowMainSubDropdown={this.state.isShowMainSubDropdown}
            keySubWork={this.state.keySubWork}
            onLoadDataMain={this.getListMainWorkTypesData}
            keyMainWork={this.state.keyMainWork}
            onLoadDataSub={this.getListSubWorkTypesData}
            isWorkSchedule={this.props.isWorkSchedule}
            reflectWorkTotal={reflectWorkTotal}
            workDayWorkersStatus={workDayWorkersStatus}
            getWorkDayWorkerDescription={this.getWorkDayWorkerDescription}
            checkInReflectToResultFlag={checkInReflectToResultFlag}
            isShowSptDropdown={isShowSptDropdown}
          />
        </div>
        <Confirmation
          visible={this.state.isShowPopupError}
          title={messageUtility.getMessage('E-001-402')}
          message={messageUtility.getMessage('I-001-506')}
          confirmButtonText={messageUtility.getMessage('I-000-180')}
          cancelButtonText={messageUtility.getMessage('I-000-017')}
          onConfirm={() => window.location.reload()}
          onCancel={() => this.closeConfirmDialog()}
          effectiveButtonClassName={'btn--sub'}
          multilineText={true}
        />
        <Confirmation
          visible={this.state.isShowPopupCheckBeforeDeletingWork}
          title={'作業予定の削除'}
          message={this.state.checkBeforeDeletingWorkMessage}
          isNegative={true}
          confirmButtonText={messageUtility.getMessage('I-000-018')}
          cancelButtonText={messageUtility.getMessage('I-000-017')}
          onConfirm={() => {
            this.deleteWorkSchedule(false);
            dialogLoader.close();
          }}
          onCancel={() => this.closeConfirmDialogCheckBeforeDeletingWork()}
          effectiveButtonClassName={'btn--sub'}
          multilineText={true}
        />
      </div>
    );
  }
}

const WorkScheduleRegisterHeader = ({
  vw,
  callbacks,
  stateHandlingFlag,
  approvedFlag = false,
  partnerCompanyApprovalFlag,
  oxygenLackPrintFlag,
  isExistOxygenLack,
  isWorkSchedule,
  unapprovedFlag,
  loaded,
  pageTitle,
  validate,
  requiredInput,
}) => {
  const styles = {
    title: {
      display: 'flex',
      alignItems: 'center',
    },
    titleText: {
      marginRight: 20,
    },
  };

  return (
    <ConferencePageHeader
      loaded={loaded}
      loaderComponent={
        <div className='slide-view__title' style={styles.title}>
          <ClipLoader size={20} color={'#EDB715'} />
        </div>
      }
      title={<div className='slide-view__title'>{pageTitle}</div>}
      leftComponent={
        <React.Fragment>
          {!approvedFlag && !partnerCompanyApprovalFlag && (
            <React.Fragment>
              {!stateHandlingFlag && (
                <button
                  id='open-confirm-close'
                  className='btn--effective slide-view__header--button'
                  onClick={() => callbacks.form.update()}
                >
                  更新
                </button>
              )}
              {!unapprovedFlag && (
                <React.Fragment>
                  <button
                    id='open-confirm-close'
                    className='btn--negative slide-view__header--button'
                    onClick={() => callbacks.modal.showDelete()}
                  >
                    削除
                  </button>
                  {stateHandlingFlag ? (
                    <button
                      id='open-confirm-close'
                      className='btn--effective slide-view__header--button'
                      onClick={() => callbacks.modal.showResume()}
                    >
                      中止の取り消し
                    </button>
                  ) : (
                    <button
                      id='open-confirm-close'
                      className='btn--sub slide-view__header--button'
                      onClick={() => callbacks.modal.showAbort()}
                    >
                      作業中止
                    </button>
                  )}
                </React.Fragment>
              )}
            </React.Fragment>
          )}
          {!unapprovedFlag &&
            isWorkSchedule &&
            sessionStorage.getItem('date_from') ===
              sessionStorage.getItem('date_to') &&
            !stateHandlingFlag &&
            isExistOxygenLack &&
            oxygenLackPrintFlag === 1 &&
            isLoginUserPartnerCompany() && (
              <button
                id='open-confirm-close'
                className='btn--sm--sub slide-view__header--button'
                onClick={() => callbacks.form.print()}
              >
                酸欠帳票印刷
              </button>
            )}
        </React.Fragment>
      }
      rightComponent={
        <React.Fragment>
          <div className='slide-view__header-end-item'>
            <div className='form-list__header-alert show'>
              {validate.invalid ? '入力エラーがあります。' : ''}
            </div>
          </div>
          <div className='slide-view__header-end-item'>
            {_.isNull(requiredInput.total)
              ? ''
              : `必須項目の入力数 ${requiredInput.count}/${
                  requiredInput.total
                }`}
          </div>
        </React.Fragment>
      }
      onClose={() => {
        if (approvedFlag || partnerCompanyApprovalFlag) {
          if (unapprovedFlag) {
            EventMg.trigger(MY_EVENT.LOAD_GROUP_DATA, true);
          }
          _slideLoader.close(vw); // 承認済みの作業は編集できないので、ダイアログを出さずに閉じる
        } else {
          callbacks.modal.goBack();
        }
      }}
    />
  );
};

class DeleteDialog extends React.Component {
  render() {
    const { isWorkSchedule } = this.props.dialog;
    return (
      <div
        className='dialog-md dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>
            作業{isWorkSchedule ? '予定' : '実績'}の削除
          </span>
        </div>
        <div className='dialog-md__body text-center'>
          データを削除します。この作業は取り消せません
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            id='modal-close-copy'
            className='btn--sm--sub'
            onClick={() => dialogLoader.close()}
          >
            戻る
          </button>
          <button
            id='modal-submit-copy'
            className='btn--sm--negative'
            onClick={() => {
              this.props.dialog.callback.deleteSchedule();
            }}
          >
            削除
          </button>
        </div>
      </div>
    );
  }
}

class AbortDialog extends React.Component {
  render() {
    const { isWorkSchedule } = this.props.dialog;
    return (
      <div
        className='dialog-md dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>
            作業{isWorkSchedule ? '予定' : '実績'}の中止
          </span>
        </div>
        <div className='dialog-md__body text-center'>
          作業{isWorkSchedule ? '予定' : '実績'}を中止します。
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            id='modal-close-copy'
            className='btn--sm--sub'
            onClick={() => dialogLoader.close()}
          >
            戻る
          </button>
          <button
            id='modal-submit-copy'
            className='btn--sm--negative'
            onClick={() => {
              this.props.dialog.callback.abortSchedule();
            }}
          >
            中止する
          </button>
        </div>
      </div>
    );
  }
}

class ResumeDialog extends React.Component {
  render() {
    const { isWorkSchedule } = this.props.dialog;
    return (
      <div
        className='dialog-md dialog--modal'
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div className='dialog-md__header'>
          <span className='dialog-md__title'>
            中止した作業{isWorkSchedule ? '予定' : '実績'}の解除
          </span>
        </div>
        <div className='dialog-md__body text-center'>
          中止した作業{isWorkSchedule ? '予定' : '実績'}
          を解除します。
        </div>
        <div className='dialog-md__footer-horizontal'>
          <button
            id='modal-close-copy'
            className='btn--sm--sub'
            onClick={() => dialogLoader.close()}
          >
            戻る
          </button>
          <button
            id='modal-submit-copy'
            className='btn--sm--negative'
            onClick={() => {
              this.props.dialog.callback.resumeSchedule();
            }}
          >
            中止を解除する
          </button>
        </div>
      </div>
    );
  }
}

export default WorkEdit;



// WEBPACK FOOTER //
// ./src/pages/WorkEdit.jsx